import {
  AUDIENCES_GET_REQUEST,
  AUDIENCES_GET_REQUEST_FAILED,
  AUDIENCES_GET_REQUEST_SUCCESS,
  AUDIENCE_ADD_REQUEST,
  AUDIENCE_ADD_REQUEST_FAILED,
  AUDIENCE_ADD_REQUEST_SUCCESS,
  AUDIENCE_EDIT_REQUEST,
  AUDIENCE_EDIT_REQUEST_FAILED,
  AUDIENCE_EDIT_REQUEST_SUCCESS,
  AUDIENCE_REMOVE_REQUEST,
  AUDIENCE_REMOVE_REQUEST_FAILED,
  AUDIENCE_REMOVE_REQUEST_SUCCESS,
  AUDIENCE_SEARCH_REQUEST,
  AUDIENCE_SEARCH_REQUEST_FAILED,
  AUDIENCE_SEARCH_REQUEST_SUCCESS,
  AUDIENCE_GET_PRESETS,
  AUDIENCE_GET_PRESETS_FAILED,
  AUDIENCE_GET_PRESETS_SUCCESS,
  AUDIENCE_GET_CATEGORIES,
  AUDIENCE_GET_CATEGORIES_FAILED,
  AUDIENCE_GET_CATEGORIES_SUCCESS,
  AUDIENCE_GET_SUBCATEGORIES,
  AUDIENCE_GET_SUBCATEGORIES_FAILED,
  AUDIENCE_GET_SUBCATEGORIES_SUCCESS,
  AUDIENCE_SUBCATEGORIES_CLEAR,
  AUDIENCE_GET_VARIABLES,
  AUDIENCE_GET_VARIABLES_FAILED,
  AUDIENCE_GET_VARIABLES_SUCCESS,
  AUDIENCE_VARIABLES_CLEAR,
  AUDIENCE_GET_COUNTRIES,
  AUDIENCE_GET_COUNTRIES_SUCCESS,
  AUDIENCE_GET_COUNTRIES_FAILED,
  AUDIENCE_GET_STATS,
  AUDIENCE_GET_STATS_FAILED,
  AUDIENCE_GET_STATS_SUCCESS,
  AUDIENCE_CLEAR_STATS,
  GET_REGIONS,
  GET_REGIONS_SUCCESS,
  ADD_REGIONS_SUCCESS,
  DELETE_REGIONS_SUCCESS,
  GET_REGIONS_FAILED,
  GET_REGION_MAP,
  GET_REGION_MAP_SUCCESS,
  GET_REGION_MAP_FAILED,
  AUDIENCE_GET_MAP,
  AUDIENCE_GET_MAP_SUCCESS,
  AUDIENCE_GET_MAP_FAILED,
  AUDIENCE_GET_TAGS,
  AUDIENCE_GET_TAGS_FAILED,
  AUDIENCE_GET_TAGS_SUCCESS,
  AUDIENCE_CLEAR_TAGS,
  AUDIENCE_GET_DESCRIPTON,
  AUDIENCE_GET_DESCRIPTON_SUCCESS,
  AUDIENCE_GET_DESCRIPTON_FAILED,
  AUDIENCE_CLEAR_DESCRIPTION,
  AUDIENCE_GET_DEMOGRAPHICS,
  AUDIENCE_GET_DEMOGRAPHICS_SUCCESS,
  AUDIENCE_GET_DEMOGRAPHICS_FAILED,
  AUDIENCE_SET_AUDIENCES_OFFSET,
  AUDIENCE_SET_PRESETS_OFFSET,
  AUDIENCE_PRESETS_CLEAR,
  AUDIENCE_AUDIENCES_CLEAR,
  AUDIENCE_CLEAR_STATE_BEFORE_NEW_SEARCH,
  AUDIENCE_SAM_MAP_REQUEST,
  AUDIENCE_SAM_MAP_SUCCESS,
  AUDIENCE_SAM_MAP_FAILED,
  AUDIENCE_ATTACH_FILE_REQUEST,
  AUDIENCE_ATTACH_FILE_SUCCESS,
  AUDIENCE_ATTACH_FILE_FAILED,
  AUDIENCE_GET_AUDIENCE_BY_ID_REQUEST,
  AUDIENCE_GET_AUDIENCE_BY_ID_SUCCESS,
  AUDIENCE_GET_AUDIENCE_BY_ID_FAILED,
  CLEAR_SAM_MAP_DATA
} from "../../constants";

const initialState = {
  data: [],
  audiencesNext: "",
  audiencesOffset: 0,
  added: {},
  removed: {},
  isAudienceRemoveSuccess: false,
  edited: {},
  search: [],
  backendSearch: [],
  backendSearchOffset: 0,
  presets: [],
  presetsNext: "",
  presetsOffset: 0,
  isPresetsLoading: false,
  categories: [],
  subcategories: [],
  variables: [],
  countries: [],
  tags: [],
  stats: {},
  regionsList: [],
  regionsMap: [],
  singleAudience: {},
  samMap: {},
  // map: {},
  map: [],
  description: [],
  demographics: [],
  searchString: "",
  isLoading: false,
  isLoadingPersonaDescription: false,
  isLoadingTags: false,
  isLoadingStats: false,
  isLoadingAudiences: false,
  isLoadingPresets: false,
  isLoadingRegions: false,
  isLoadingRegionsMap: false,
  isLoadingSamMap: false,
  error: {},
  isAttachFileLoading: false,
  isLoadingSingleAudience: false
};

function getUniqById(state, newState) {
  const result = [
    ...state,
    ...newState.filter(item => {
      return !state.some(stateItem => stateItem.id === item.id);
    })
  ];
  return result;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case AUDIENCE_GET_AUDIENCE_BY_ID_REQUEST:
      return {
        ...state,
        isLoadingSingleAudience: true
      };
    case AUDIENCE_GET_AUDIENCE_BY_ID_SUCCESS:
      return {
        ...state,
        singleAudience: action.payload,
        isLoadingSingleAudience: false
      };
    case AUDIENCE_GET_AUDIENCE_BY_ID_FAILED:
      return {
        ...state,
        isLoadingSingleAudience: false
      };

    case AUDIENCE_ATTACH_FILE_REQUEST:
      return {
        ...state,
        isAttachFileLoading: true
      };

    case AUDIENCE_ATTACH_FILE_SUCCESS:
      return {
        ...state,
        isAttachFileLoading: false
      };

    case AUDIENCE_ATTACH_FILE_FAILED:
      return {
        ...state,
        isAttachFileLoading: false,
        error: action.payload
      };

    case AUDIENCE_CLEAR_STATE_BEFORE_NEW_SEARCH:
      return {
        ...state,
        audiencesOffset: 0,
        audiencesNext: "",
        presetsOffset: 0,
        presetsNext: "",
        data: [],
        presets: []
      };

    case AUDIENCE_SAM_MAP_REQUEST:
      return {
        ...state,
        isLoadingSamMap: true,
        samMap: {}
      };

    case AUDIENCE_SAM_MAP_SUCCESS:
      return {
        ...state,
        samMap: action.payload,
        isLoadingSamMap: false
      };
    case CLEAR_SAM_MAP_DATA:
      return {
        ...state,
        samMap: {}
      };
    case AUDIENCE_SAM_MAP_FAILED:
      return {
        ...state,
        samMap: {},
        isLoadingSamMap: false,
        error: action.payload
      };

    case AUDIENCE_SET_AUDIENCES_OFFSET:
      return {
        ...state,
        audiencesOffset: action.payload
      };
    case AUDIENCE_SET_PRESETS_OFFSET:
      return {
        ...state,
        presetsOffset: action.payload
      };

    case AUDIENCE_GET_MAP:
    case AUDIENCE_GET_COUNTRIES:
    case AUDIENCE_GET_CATEGORIES:
    case AUDIENCE_GET_SUBCATEGORIES:
    case AUDIENCE_GET_VARIABLES:
      return {
        ...state,
        isLoading: true
      };

    case AUDIENCES_GET_REQUEST:
      return {
        ...state,
        isLoadingAudiences: true
      };

    case AUDIENCE_GET_STATS:
      return { ...state, isLoadingStats: true };

    case GET_REGIONS:
      return { ...state, isLoadingRegions: true };

    case GET_REGION_MAP:
      return { ...state, isLoadingRegionsMap: true };

    case AUDIENCE_GET_TAGS:
      return { ...state, isLoadingTags: true };

    case AUDIENCE_GET_DESCRIPTON:
      return {
        ...state,
        isLoadingPersonaDescription: true
      };

    case AUDIENCE_ADD_REQUEST:
      return {
        ...state,
        added: action.payload,
        isLoadingAudiences: true
      };

    case AUDIENCE_EDIT_REQUEST:
      return {
        ...state,
        edited: action.payload,
        isLoading: true
      };
    case AUDIENCE_REMOVE_REQUEST:
      return {
        ...state,
        removed: action.payload,
        isAudienceRemoveSuccess: false,
        isLoading: true
      };
    case AUDIENCE_SEARCH_REQUEST:
      return {
        ...state,
        searchString: action.payload,
        isLoading: true
      };
    case AUDIENCE_GET_DEMOGRAPHICS:
      return {
        ...state,
        isLoading: true
      };
    case AUDIENCES_GET_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload.isNewBackendSearchOrFiltering
          ? action.payload.data
          : [...state.data, ...action.payload.data],
        audiencesNext: action.payload.next || "",
        isLoadingAudiences: false,
        error: {}
      };

    case AUDIENCE_AUDIENCES_CLEAR:
      return { ...state, data: [], audiencesNext: "" };

    case AUDIENCE_ADD_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
        added: action.payload,
        isLoading: false,
        error: {}
      };
    case AUDIENCE_EDIT_REQUEST_SUCCESS:
      return {
        ...state,
        data: [
          // ...state.data.filter(({ id }) => id !== action.payload.id),
          // action.payload
          ...state.data.map(audience =>
            audience.id === action.payload.id ? action.payload : audience
          )
        ],
        edited: action.payload,
        isLoading: false,
        error: {}
      };
    case AUDIENCE_REMOVE_REQUEST_SUCCESS:
      return {
        ...state,
        data: [...state.data.filter(({ id }) => id !== action.payload)],
        removed: {},
        isLoading: false,
        isAudienceRemoveSuccess: true,
        error: {}
      };
    case AUDIENCE_SEARCH_REQUEST_SUCCESS:
      return {
        ...state,
        search: [...action.payload],
        isLoading: false,
        error: {}
      };

    case AUDIENCE_GET_PRESETS:
      return {
        ...state,
        isLoadingPresets: true,
        error: {}
      };

    case AUDIENCE_GET_PRESETS_SUCCESS: {
      return {
        ...state,
        presets: action.payload.isNewBackendSearchOrFiltering
          ? action.payload.results
          : [...state.presets, ...action.payload.results],
        presetsNext: action.payload.next || "",
        isLoadingPresets: false,
        error: {}
      };
    }

    case AUDIENCE_PRESETS_CLEAR:
      return { ...state, presets: [], presetsNext: "" };

    case AUDIENCE_GET_PRESETS_FAILED:
      return {
        ...state,
        isLoadingPresets: false,
        error: action.payload
      };

    case AUDIENCE_GET_CATEGORIES_SUCCESS: {
      const categories = action.payload;
      return {
        ...state,
        categories,
        isLoading: false,
        error: {}
      };
    }

    case AUDIENCE_GET_SUBCATEGORIES_SUCCESS: {
      const subcategories = getUniqById(state.subcategories, action.payload);

      return {
        ...state,
        subcategories,
        isLoading: false,
        error: {}
      };
    }

    case AUDIENCE_SUBCATEGORIES_CLEAR: {
      return { ...state, subcategories: [] };
    }

    case AUDIENCE_GET_VARIABLES_SUCCESS: {
      const variables = getUniqById(state.variables, action.payload);

      return {
        ...state,
        variables,
        isLoading: false,
        error: {}
      };
    }

    case AUDIENCE_VARIABLES_CLEAR: {
      return { ...state, variables: [] };
    }

    case AUDIENCE_GET_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: [...action.payload],
        isLoading: false,
        error: {}
      };

    case AUDIENCE_GET_STATS_SUCCESS:
      return {
        ...state,
        stats: { ...action.payload },
        isLoadingStats: false,
        error: {}
      };

    case GET_REGIONS_SUCCESS:
      return {
        ...state,
        regionsList: action.payload,
        isLoadingRegions: false,
        error: {}
      };

    case ADD_REGIONS_SUCCESS:
      return {
        ...state,
        regionsList: [...state.regionsList, action.payload],
        error: {}
      };

    case DELETE_REGIONS_SUCCESS: {
      const res = state.regionsList.filter(item => item.id !== action.payload);
      return {
        ...state,
        regionsList: res,
        error: {}
      };
    }

    case GET_REGION_MAP_SUCCESS:
      return {
        ...state,
        regionsMap: action.payload,
        isLoadingRegionsMap: false,
        error: {}
      };

    case AUDIENCE_CLEAR_STATS:
      return {
        ...state,
        stats: {}
      };

    case AUDIENCE_GET_MAP_SUCCESS:
      return {
        ...state,
        // map: action.payload,
        map: [...action.payload],
        isLoading: false,
        error: {}
      };

    case AUDIENCE_GET_TAGS_SUCCESS:
      return {
        ...state,
        tags: [...action.payload],
        isLoadingTags: false,
        error: {}
      };

    case AUDIENCE_CLEAR_TAGS:
      return {
        ...state,
        tags: []
      };

    case AUDIENCE_GET_DESCRIPTON_SUCCESS:
      return {
        ...state,
        description: [...action.payload],
        isLoadingPersonaDescription: false,
        error: {}
      };

    case AUDIENCE_CLEAR_DESCRIPTION:
      return { ...state, description: [] };

    case AUDIENCE_GET_DEMOGRAPHICS_SUCCESS:
      return {
        ...state,
        demographics: [...action.payload],
        isLoading: false,
        error: {}
      };

    case AUDIENCE_GET_DESCRIPTON_FAILED:
      return {
        ...state,
        isLoadingPersonaDescription: false,
        error: action.payload
      };

    case AUDIENCE_GET_TAGS_FAILED:
      return { ...state, isLoadingTags: false, error: action.payload };

    case AUDIENCE_GET_STATS_FAILED:
      return { ...state, isLoadingStats: false, error: action.payload };

    case GET_REGIONS_FAILED:
      return { ...state, isLoadingRegions: false, error: action.payload };

    case GET_REGION_MAP_FAILED:
      return { ...state, isLoadingRegionsMap: false, error: action.payload };

    case AUDIENCE_GET_MAP_FAILED:
    case AUDIENCE_GET_COUNTRIES_FAILED:
    case AUDIENCE_SEARCH_REQUEST_FAILED:
    case AUDIENCE_ADD_REQUEST_FAILED:
    case AUDIENCE_EDIT_REQUEST_FAILED:
    case AUDIENCE_REMOVE_REQUEST_FAILED:
    case AUDIENCE_GET_CATEGORIES_FAILED:
    case AUDIENCE_GET_SUBCATEGORIES_FAILED:
    case AUDIENCE_GET_VARIABLES_FAILED:
    case AUDIENCE_GET_DEMOGRAPHICS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case AUDIENCES_GET_REQUEST_FAILED:
      return {
        ...state,
        isLoadingAudiences: false,
        error: action.payload
      };

    default:
      return state;
  }
};
